import { render } from "./SupportedPartners.vue?vue&type=template&id=68e9b7f4&scoped=true&ts=true"
import script from "./SupportedPartners.vue?vue&type=script&lang=ts"
export * from "./SupportedPartners.vue?vue&type=script&lang=ts"

import "./SupportedPartners.vue?vue&type=style&index=0&id=68e9b7f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68e9b7f4"]])

export default __exports__